export const API = 'https://api.exams.africa/api/v1'

// ''
// https://api.exams.africa/api/v1

// export const API = 'https://api.mockexams.ng/api/v1'

// ''